import {Component, EventEmitter, OnInit, Output, ViewEncapsulation} from "@angular/core";
import * as moment from "moment";
import {FormControl, FormGroup} from "@angular/forms";
import {CourseManagementService} from "@tva/ng-migration/course-management/services/course-management.service";
import {schoolwork12} from "@tva/ng-migration/common/util";


@Component({
  selector: "app-course-management-search-form",
  templateUrl: "./course-management-search-form.component.html",
  styleUrls: ["./course-management-search-form.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CourseManagementSearchFormComponent implements OnInit {
  filters = {
    status: [
      { id: 1, label: "Active" },
      { id: 0, label: "Inactive" },
    ],
    courseSubjectList: [],
    courseNameCriteria: [
      { id: 0, label: "Starts with" },
      { id: 1, label: "Contains" },
      { id: 2, label: "Ends with" },
    ],
    courseCodeCriteria: [
      { id: 0, label: "Starts with" },
      { id: 1, label: "Contains" },
      { id: 2, label: "Ends with" },
    ],
    gradeLevelList: [],
    courseLevelList: [],
    courseLengthList: [],
    courseTypeList: [],
    courseContentTypeList: [],
    courseVendorList: [],
    stateList: [],
  };

  isSearching: boolean;
  isLoadingFilters = true;
  wasValidated;

  form = new FormGroup({
    status: new FormControl(),
    courseSubjectList: new FormControl(),
    courseNameCriteria: new FormControl(),
    courseName: new FormControl(),
    courseCodeCriteria: new FormControl(),
    courseCode: new FormControl(),
    createDateFrom: new FormControl(),
    createDateTo: new FormControl(),
    gradeLevelList: new FormControl(),
    courseLevelList: new FormControl(),
    courseLengthList: new FormControl(),
    courseTypeList: new FormControl(),
    courseContentTypeList: new FormControl(),
    courseVendorList: new FormControl(),
    stateList: new FormControl(),
  });

  @Output() searched = new EventEmitter<any>();

  get errors() {
    return {
      createDateFrom: {
        matDatepickerParse: schoolwork12.app.manageCourseManagement.errorMessages.invalidCreateDateFrom
      },
      createDateTo: {
        matDatepickerParse: schoolwork12.app.manageCourseManagement.errorMessages.invalidCreateDateTo
      }
    }
  }

  constructor(
    private courseManagementService: CourseManagementService,
  ) {
  }

  ngOnInit(): void {
    this.clearFilters();
    this.loadFilters();
  }

  private loadFilters(): void {
    this.courseManagementService.getCourseManagementSearchFilters().subscribe((filters) => {
      for (const filter in filters) {
        this.filters[filter].push(...filters[filter]);
      }
      this.filters.courseSubjectList.sort((a, b) => a.name.localeCompare(b.name));
      this.filters.gradeLevelList.sort((a, b) => a.weight - b.weight);
      this.filters.courseLevelList.sort((a, b) => a.name.localeCompare(b.name));
      this.filters.courseLengthList.sort((a, b) => a.name.localeCompare(b.name));
      this.filters.courseTypeList.sort((a, b) => a.name.localeCompare(b.name));
      this.filters.courseContentTypeList.sort((a, b) => a.name.localeCompare(b.name));

      this.isLoadingFilters = false;
    });
  }

  private getFilters(): any {
    const filters = { ...this.form.value };

    if (filters.createDateTo) {
      filters.createDateTo = moment(filters.createDateTo).format("L");
    }
    if (filters.createDateFrom) {
      filters.createDateFrom = moment(filters.createDateFrom).format("L");
    }
    return filters;
  }

  private validateForm(): boolean {
    this.wasValidated = true;
    return this.form.valid;
  }

  public clearFilters(): void {
    this.form.setValue({
      status: 1,
      courseSubjectList: null,
      courseNameCriteria: 0,
      courseName: "",
      courseCodeCriteria: 0,
      courseCode: "",
      createDateFrom: null,
      createDateTo: null,
      gradeLevelList: null,
      courseLevelList: null,
      courseLengthList: null,
      courseTypeList: null,
      courseContentTypeList: null,
      courseVendorList: null,
      stateList: null,
    });
  }

  public search(): void {
    if (this.validateForm()) {
      this.isSearching = true;
      this.courseManagementService.searchCourses(this.getFilters()).subscribe((data) => {
        // this.searched.emit(data);
        data.forEach((row) => {
          row.createDate = new Date(row.createDate);
          row.modifyDate = new Date(row.modifyDate);
          row.specifiedStatesText = row.specifiedStates
            .map((course) => {
              return course.code;
            })
            .join("; ");
          row.courseVendorsText = row.courseVendors
            .map((courseVendor) => courseVendor.name)
            .join("; ");
          row.nextCoursesText = row.nextCourses
            .map((nextCourse) => nextCourse.nextCourseCode)
            .join("; ");
        });
        this.searched.emit(data);
      }, () => { }, () => {
        this.isSearching = false;
      });
    }
  }
}
